import React, { Component, Fragment } from "react";
import api from "../../services/api";

import Dashboard from "../../components/Dashboard";
class Home extends Component {
  state = {
    companyStatusDescription: "",
    companies: []
  };
  async componentDidMount() {
    if (localStorage.getItem("cnpj")) {
      try {
        const response = await api.get(
          `/companies?cnpj=${localStorage.getItem("cnpj")}`
        );
        if (response.data.rows.length) {
          let dados = response.data.rows[0];
          this.setState({
            companyStatusDescription: dados.CompanyStatus.description,
          });

         
        }

        if(localStorage.getItem("UserTypeId") == 1){
          const getList = await api.get(
            `/companies/ListCompanies`
          );
  
        
          if (getList.data.Companies.length) {         
            
            this.setState({ 
              companies : getList.data.Companies });
        
           
          }
        }
        
      } catch (err) {
        console.log(err);
      }
    }
  }

  selectCompany = e => {
    // this.setState({ SectorId: e.target.value });
   

     api.post(`/auth/defense-cdi`, {
      ic: e.target.value ,
     
  }).then(async (result) => {

    this.setState({ userLogin: result.data.user, token: result.data.token });
    localStorage.setItem('CompanyId', result.data.user.CompanyId);
     
     await api.get(`/companies/${localStorage.getItem('CompanyId')}`).then(async (result) => {

         localStorage.setItem('token', this.state.token);
         localStorage.setItem('name', this.state.userLogin.name);
         localStorage.setItem('email', this.state.userLogin.email);
         localStorage.setItem('userId', this.state.userLogin.id);
         localStorage.setItem('UserTypeId', this.state.userLogin.UserTypeId);
         localStorage.setItem('SectorId', this.state.userLogin.SectorId);

         localStorage.setItem('businessName', result.data.data.businessName);
         localStorage.setItem('cnpj', result.data.data.cnpj);
         localStorage.setItem('CompanyTypeId', result.data.data.CompanyTypeId);

         await api.get(`/companies?cnpj=${result.data.data.cnpj}`).then((result1) => {
             if (result1.data.rows.length) {
                 localStorage.setItem('companyStatusId', result1.data.rows[0].CompanyStatus.id);
                 localStorage.setItem('companyStatus', result1.data.rows[0].CompanyStatus.description);
             }
         });
     });

     window.location.href = './home';

  }).catch(error => {
    console.log("DEFENSE ERROR " + error);
  });







  };

  render() {
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">Home</h3>
          </div>
        </div>
        <div className="row">
          {/* <Dashboard /> */}
          {/* <div className="alert alert-success">
                        <i className="ti-user"></i>
                        <strong>Bem vindo.</strong>
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div> */}
        </div>

        {(() => {
          switch (localStorage.getItem("UserTypeId")) {
            case "1":
              return (
                <div className="row">
                  <div className="col-md-8">
                    <h5>Ao selecionar uma empresa, seu login será desativado temporariamente até que ocorra o logout</h5>
                    <select
                      className="custom-select col-md-12"
                      onChange={this.selectCompany}
                    >   
                     <option value=""></option>                   
                      {this.state.companies.map((item, index) => {
                            return (
                              <option key={index} value={item.id}>
                                {item.socialName}
                              </option>
                            );
                          })
                        }
                    </select>
                    <br />
                    <br />
                  </div>
                </div>
              );

            case "2":
              return (
                <div className="row">
                  <div
                    className={
                      this.state.companyStatusDescription == "Habilitado"
                        ? "alert alert-success"
                        : this.state.companyStatusDescription == "Habilitado com Pendências"
                        ? "alert alert-warning"
                        : this.state.companyStatusDescription == "Aguardando Aprovação"
                        ? "alert alert-info"
                        : "alert alert-primary"
                    }
                  >
                    <span>
                      Status da empresa:
                      <strong> {this.state.companyStatusDescription}</strong>
                    </span>
                  </div>
                </div>
              );
            default:
              return null;
          }
        })()}

        <div
          className="alert alert-primary"
          style={{
            position: "absolute",
            fontSize: 13,
            bottom: 75,
            right: 10,
            height: "70px",
            width: "500px",
          }}
        >
          <b>Cookies:</b> Este site faz o uso de cookies para avaliar as
          interações dos usuários (Google Analytics) visando melhorar a
          experiência entregue pela aplicação.<br></br>
        </div>

        <div
          className="alert alert-warning"
          style={{
            position: "absolute",
            fontSize: 13,
            bottom: 0,
            right: 10,
            height: "60px",
            width: "500px",
          }}
        >
          Antes de acessa este website e/ou interagir com a plataforma, clique{" "}
          <a
            href="https://cdi.dpworldsantos.com/DPWS_Aviso_de_Privacidade.pdf"
            target="_blank"
          >
            aqui
          </a>{" "}
          para ler e conhecer o Aviso de Privacidade da DP World Santos.
        </div>
      </Fragment>
    );
  }
}

export default Home;
